import { baseApi } from '@/api/rtk/baseApi';

export const selectUserResult = (state, userId) => {
  if (!userId) return undefined;
  return baseApi.endpoints.getUser.select({ userId })(state);
};

export const selectUserData = (state) => {
  const userId = localStorage.getItem('user_id');
  return selectUserResult(state, userId)?.data ?? null;
};

export const selectUserLoading = (state) => {
  const userId = localStorage.getItem('user_id');
  const result = selectUserResult(state, userId);
  return !!result && (result.isLoading || result.isFetching) && !result.data;
};

export const selectUserFailed = (state) => {
  const userId = localStorage.getItem('user_id');
  const result = selectUserResult(state, userId);
  return !!result?.isError;
};

export const selectLanguage = (state) => selectUserData(state)?.language ?? null;
export const getTokenCount = (state) => selectUserData(state)?.tokens ?? null;
export const getPayingCustomer = (state) => selectUserData(state)?.paying_org ?? null;
export const getTrialEndDate = (state) => selectUserData(state)?.org_trial_end_date ?? null;
export const selectNotification = (state) => selectUserData(state)?.notification ?? '';
